/**
 * ============================================================================
 * GET METRIC DEFINITIONS API — accessor for POST /getMetricDefinitions.
 * ============================================================================
 *
 * LAYER: accessor. The dashboard's metric catalog (presentation metadata for
 * every metric, ordered by sortOrder). Constant across DCRs and weeks, so
 * callers fetch it once per session and join it to getMetrics by metricKey.
 *
 * Not paginated — the catalog is the full metric set in one response.
 */

import { ReportingApiClient } from 'src/accessors/ReportingApiClient';
import { GetMetricDefinitionsInput, GetMetricDefinitionsOutput } from 'src/types/metricsApi.types';

class GetMetricDefinitionsApiClient extends ReportingApiClient {
  public async getMetricDefinitions(
    input: GetMetricDefinitionsInput,
  ): Promise<GetMetricDefinitionsOutput> {
    return this.post<GetMetricDefinitionsOutput>('/getMetricDefinitions', input);
  }
}

/** Singleton (portal convention): one shared instance app-wide. */
export const GetMetricDefinitionsApi = new GetMetricDefinitionsApiClient();
